import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { BaseRepository } from '../Common/Data/base.repository';

@Injectable({ providedIn: 'root' })
export class ProcessingRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    private readonly QUICK_SEARCH_SERVICE_URL = '/api/search';
    private readonly DUPLICATE_SERVICE_URL = '/api/documentintake/duplicate';
    private readonly DUPLICATE_BULK_SERVICE_URL = `${this.DUPLICATE_SERVICE_URL}/bulk`;

    search(query) {
        return this.httpPost(`${this.QUICK_SEARCH_SERVICE_URL}/quick`, query);
    }

    processDocumentException(
        documentID,
        taskID,
        entityDetails,
        actionID,
        newAssignment,
        commentBody,
        newDocumentTypeID,
        data,
        intakeItemRowVersion,
        parcelChanges,
    ) {
        const documentTaskExceptionEndpoint = `/api/Processing/Document/${documentID}/Task/${taskID}/Exception`;
        const processedEntityDetails = entityDetails.entityID !== null ? entityDetails : null;

        const exceptionDataObj = {
            documentExceptionAction: actionID,
            associatedEntity: processedEntityDetails,
            newAssignment: newAssignment,
            commentBody: commentBody,
            newDocumentTypeID: newDocumentTypeID,
            entryJSON: data,
            intakeItemRowVersion: intakeItemRowVersion,
            parcelChanges: parcelChanges,
        };
        return this.httpPut(documentTaskExceptionEndpoint, exceptionDataObj);
    }

    processDocumentBulkException(payload) {
        return this.httpPost('/api/Processing/Document/BulkException', payload);
    }

    completeItem(
        documentID,
        taskID,
        entityDetails,
        newDocumentTypeID,
        data,
        intakeItemRowVersion,
        parcelChanges,
        extraInfoJSON,
    ) {
        const documentTaskProcessingEndpoint = `/api/Processing/Document/${documentID}/Task/${taskID}/Complete`;
        return this.httpPut(documentTaskProcessingEndpoint, {
            associatedEntity: entityDetails,
            entryJSON: data,
            newDocumentTypeID: newDocumentTypeID,
            intakeItemRowVersion: intakeItemRowVersion,
            parcelChanges: parcelChanges,
            extraInfoJSON,
        });
    }

    saveItemEntity(
        documentID,
        taskID,
        entityDetails,
        newDocumentTypeID,
        data,
        intakeItemRowVersion,
        parcelChanges,
        extraInfoJSON,
    ): Observable<any> {
        const documentTaskProcessingEndpoint = `/api/Processing/Document/${documentID}/Task/${taskID}`;
        return this.httpPut(documentTaskProcessingEndpoint, {
            associatedEntity: entityDetails,
            entryJSON: data,
            newDocumentTypeID: newDocumentTypeID,
            intakeItemRowVersion: intakeItemRowVersion,
            parcelChanges: parcelChanges,
            extraInfoJSON,
        });
    }

    getEntityTree(entityTypeId: number, entityId: number, extended: boolean): Observable<Core.EntityTree> {
        let entityTreeEndpoint;
        if (extended) {
            entityTreeEndpoint = '/api/entityTree/extended/entityType/';
        } else {
            entityTreeEndpoint = '/api/entityTree/entityType/';
        }

        entityTreeEndpoint = `${entityTreeEndpoint + entityTypeId}/entity/${entityId}`;
        return this.httpGet(entityTreeEndpoint);
    }

    //call API with list
    createDuplicateIntakeItem(duplicateItem): Observable<any> {
        return this.httpPost(this.DUPLICATE_SERVICE_URL, duplicateItem);
    }

    createDuplicateIntakeItemBulk(duplicateItem): Observable<any> {
        return this.httpPost(this.DUPLICATE_BULK_SERVICE_URL, duplicateItem);
    }

    //call API with single

    processNoAppealWarranted(payload): Observable<Core.BulkOperationResult[]> {
        return this.httpPost('/api/processing/assessment/noappeal', payload);
    }

    processAppealWarranted(payload, isForlitigationReferral?: boolean): Observable<Core.BulkOperationResult[]> {
        const options =
            typeof isForlitigationReferral === 'boolean'
                ? { params: { isForlitigationReferral: isForlitigationReferral.toString() } }
                : undefined;

        return this.httpPost('/api/processing/assessment/appealwarranted', payload, options);
    }

    completeFileAppeal(payload): Observable<any> {
        return this.httpPut('/api/Tasks/completefileappeals', payload);
    }

    getAppealLevels(taskIDs: number[]): Observable<any> {
        return this.httpPost('/api/processing/assessment/appeallevels', taskIDs);
    }

    changeDueDate(taskIDs: number[], dueDate: Date, searchTimestamp: Date): Observable<any> {
        return this.httpPut('/api/tasks/changeduedates', {
            taskIDs: taskIDs,
            dueDate: dueDate,
            searchTimestamp: searchTimestamp,
        });
    }

    processPaymentReviewed(payload) {
        return this.httpPut('/api/tasks/processpaymentreviewed', payload);
    }

    getBulkDocumentExceptionData(taskIds: number[]): Observable<Core.BulkDocumentExceptionData> {
        return this.httpPost('/api/processing/Document/BulkException/TaskData', taskIds);
    }

    performOCR(taskIDs: number[]): Observable<any> {
        return this.httpPost(`/api/processing/performidp`, taskIDs);
    }
}
